import React from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

class CrowFieldCustomCommonDate extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			value: props.value,
		};
	}

	componentDidUpdate(prevProps) {
		if (prevProps.value !== this.props.value) {
			this.setState({
				value: this.props.value,
			});
		}
	}

	formatDate (date) {
		const { entity, value, app } = this.props;

		if (date === null) {
			app.setValue('todo', entity.name, null);
			this.setState({
				value: null,
			});
		} else {
			let iso = date.toISOString();
			app.setValue('todo', entity.name, iso);
			this.setState({
				value: date,
			});
		}
	};

	clearDate () {
		const { entity, value, app } = this.props;

		app.setValue('todo', entity.name, null);
		this.setState({
			value: null,
		});
	};

	render() {

		const { entity, } = this.props;
		let { attr = {}, } = entity || {};
		let { htmlattr, } = attr || {};

		let value = this.state.value;
		if (!value) {
			value = '';
		} else {
			// If the incoming value represents a calendar date (a date-only
			// string like "2020-12-31", or a midnight-UTC ISO timestamp like
			// "2020-12-31T00:00:00Z" — i.e. the way MySQL DATE columns
			// round-trip through Go's time.Time), construct the Date from
			// year/month/day components so it lands on midnight LOCAL time.
			// Otherwise `new Date("2020-12-31T00:00:00Z")` parses as UTC
			// midnight and the picker displays the previous day in any
			// westward browser timezone.
			let calendarMatch = (typeof value === 'string')
				&& value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s]00:00:00(?:\.000)?Z?)?$/);
			if (calendarMatch) {
				let year = Number(calendarMatch[1]);
				let month = Number(calendarMatch[2]);
				let day = Number(calendarMatch[3]);
				let localDate = new Date(year, month - 1, day);
				// Round-trip validate — JS silently rolls invalid calendar
				// dates forward (new Date(2020, 1, 30) → Mar 1, 2020), so
				// fall back to the standard parser (which returns Invalid
				// Date) so the existing isNaN guard below catches it.
				if (
					localDate.getFullYear() === year
					&& localDate.getMonth() === month - 1
					&& localDate.getDate() === day
				) {
					value = localDate;
				} else {
					value = new Date(value);
				}
			} else {
				value = new Date(value);
			}

			// Set value to current date if invalid date object
			let isValid = Date.parse(value);
			if (isNaN(isValid)) {
				value = new Date();
			}
		}

		return (
			<div className={`text-small ${(this.props.classNameList || []).join(' ')}`}>
				<div className="label">
					<label>{entity.attr.label}</label>
					{entity.attr.allowClear ? <label onClick={this.clearDate.bind(this)}> | Clear Date</label> : null}
				</div>
				<DatePicker
					id={attr['data-test-id'] || attr.name}
					selected={value}
					onChange={this.formatDate.bind(this)}
					dropdownMode="select"
					showMonthDropdown
					showYearDropdown
					{...htmlattr}
				/>
			</div>
		);
	}
}

const _exports = {
	name:  'custom.common.date',
	desc:  'Standard Date Field',
	scope: {},
	field: CrowFieldCustomCommonDate,
};

export default _exports;